import { FC, useEffect, useState } from "react";
import { IOption, Select } from "../../../../../components/selects/select";
import styles from './Motivation.module.scss'
import GridWrapper from "../../../../../components/controls/GridWrapper";
import { Button, Checkbox, InputNumber } from "antd";
import GridMultipleSelectorInputV2 from "../../../../../components/controls/GridMultipleSelectorInputV2";
import useGridFilter from "../../../../../system/hooks/useGridFilter";
import { GoodsGroupAllSelectorModal } from "../../../GoodsGroup/GoodsGroupAllSelectorModal";
import { StoreSelectorModal } from "../../../Store";
import { IEntitySimpleDTO } from "../../../../../libs/coreapi-dto/@types/common";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { IBonusCard } from "./.interface";

const BonusCard: FC<IBonusCard> = ({
    bonus,
    viewBonus,
    index,
    onUpdate,
    marginCodeOptions,
    isProAptekaEnabled,
    idContractorGlobal,
    baseT,
    onStoresChange,
    onGoodsGroupsChange,
    onAddNewBonus,
    onDeleteBonus,
}) => {
    const numberBonus = index + 1;
    const [selectedOption, setSelectedOption] = useState<IOption>(() => {
        return marginCodeOptions.find(opt => opt.value === bonus.marginCode) || marginCodeOptions[0]
    }
    );
    const selectedStores: IEntitySimpleDTO[] = viewBonus?.stores.map(store => store.store) || [];
    const selectedGoodsGroups: IEntitySimpleDTO[] = viewBonus?.goodsGroups.map(group => group.goodsGroup) || [];

    const [gridFilter, dispatchGridFilter] = useGridFilter({
        numberPerPage: 15,
        pageNumber: 1,
        columnFilters: [
            {
                name: "deleted",
                operator: "Eq",
                value: false,
            },
            {
                name: "idContractorGlobal",
                operator: "Eq",
                value: idContractorGlobal,
            },
        ]
    });

    useEffect(() => {
        setSelectedOption(
            marginCodeOptions.find(opt => opt.value === bonus.marginCode) || marginCodeOptions[0]
        );
    }, [bonus.marginCode, marginCodeOptions]);

    const handleMarginCodeChange = (option: IOption) => {
        setSelectedOption(option);
        onUpdate(index, 'marginCode', Number(option.value));
    };

    const handleEnabledStoresChange = (e: any) => {
        onUpdate(index, 'enabledStores', e.target.checked);
    };
    const handleEnabledGoodsGroupChange = (e: any) => {
        onUpdate(index, 'enabledGoodsGroups', e.target.checked);
    };

    const handleStoresSelect = (entities: IEntitySimpleDTO[]) => {
        onStoresChange?.(index, entities);
    };

    const handleGoodsGroupsSelect = (entities: IEntitySimpleDTO[]) => {
        onGoodsGroupsChange?.(index, entities);
    };

    const handleStoresClear = () => {
        onStoresChange?.(index, []);
    };

    const handleGoodsGroupsClear = () => {
        onGoodsGroupsChange?.(index, []);
    };

    return (
        <div className={`${styles.baseBlock} ${styles.topMargin}`}>
            <div className={styles.checkBoxForBlockWithBorder}>{baseT('bonus')} {numberBonus}</div>
            <GridWrapper cols={2}>
                <div className={styles.rowWrapper}>{baseT('valueBonus')}</div>
                <GridWrapper cols={2}>
                    <InputNumber
                        controls={false}
                        min={0}
                        max={99.9}
                        precision={0}
                        value={bonus.value}
                        onChange={(e) => onUpdate(index, 'value', Number(e))}
                    />
                    {(index === 0)
                        ? <div className={styles.bonusButton}>
                            <Button
                                type="text"
                                onClick={onAddNewBonus}
                                icon={<PlusOutlined style={{ color: '#009933' }} />}
                                size="large"
                                title={baseT('addBonus')}
                            />
                        </div>
                        : <div className={styles.bonusButton}>
                            <Button
                                type="text"
                                onClick={onDeleteBonus}
                                icon={<DeleteOutlined style={{ color: '#cc3333' }} />}
                                size="large"
                                title={baseT('deleteBonus')}
                            />
                        </div>}
                </GridWrapper>
            </GridWrapper>
            <GridWrapper cols={2}>
                <div className={styles.rowWrapper}>{baseT('marginCode')}</div>
                <GridWrapper cols={2}>
                    <Select
                        style={{ width: 300 }}
                        value={selectedOption}
                        options={marginCodeOptions}
                        onSelect={handleMarginCodeChange}
                    />
                </GridWrapper>
            </GridWrapper>
            <GridWrapper cols={2}>
                <GridWrapper cols={1}>
                    <Checkbox
                        checked={bonus.enabledStores}
                        onChange={(e) => {
                            const checked = e.target.checked;
                            handleEnabledStoresChange(e);
                            if (!checked) {
                                handleStoresClear();
                            }
                        }}
                        name="enabledStores"
                    >
                        {baseT('enabledStores')}
                    </Checkbox>
                    <GridMultipleSelectorInputV2
                        className={styles.width100}
                        placeholder={baseT('enabledStores')}
                        selectedEntities={selectedStores}
                        id={`idStores_${bonus.idGlobal}`}
                        switchOnchange
                        gridFilter={gridFilter}
                        selectorModalJsx={StoreSelectorModal}
                        onSelect={handleStoresSelect}
                        onClear={handleStoresClear}
                        isSearchForMultyselect
                        dataFromPluginGridSelectorInput={selectedStores}
                        disabled={!bonus.enabledStores}
                    />
                </GridWrapper>
                <GridWrapper cols={1}>
                    <Checkbox
                        checked={bonus.enabledGoodsGroups}
                        onChange={(e) => {
                            const checked = e.target.checked;
                            handleEnabledGoodsGroupChange(e);
                            if (!checked) {
                                handleGoodsGroupsClear();
                            }
                        }}
                        name="enabledGoodsGroups"
                    >
                        {baseT('enabledGoodsGroups')}
                    </Checkbox>
                    <GridMultipleSelectorInputV2
                        className={styles.width100}
                        placeholder={baseT('enabledGoodsGroups')}
                        selectedEntities={selectedGoodsGroups}
                        id={`idGoodsGroup_${bonus.idGlobal}`}
                        switchOnchange
                        isProAptekaEnabled={isProAptekaEnabled}
                        selectorModalJsx={GoodsGroupAllSelectorModal}
                        onSelect={handleGoodsGroupsSelect}
                        onClear={handleGoodsGroupsClear}
                        isSearchForMultyselect
                        dataFromPluginGridSelectorInput={selectedGoodsGroups}
                        disabled={!bonus.enabledGoodsGroups}
                    />
                </GridWrapper>
            </GridWrapper>
        </div>
    );
};
export default BonusCard